import { defineStore } from "pinia";
import { ref } from "vue";

export const useSearchStore = defineStore("search", () => {
    const files = ref("");
    const tasks = ref("");
    const assets = ref("");
    const asset_groups = ref("");
    const recurring_tasks = ref("");

    return {
        files,
        tasks,
        assets,
        asset_groups,
        recurring_tasks,
    };
});
